const StatoDichiarazione = {
  // / <summary>
  // / Dichiarazione annullata
  // / </summary>
  Annullata: 0,

  // / <summary>
  // /     Dichiarazione dell'anno precedente
  // / </summary>
  AnnoPrecedente: 5,

  // / <summary>
  // /     Dichiarazione importabile
  // / </summary>
  Importabile: 6,

  // / <summary>
  // /     Dichiarazione senza errori ma non ancora completata
  // / </summary>
  InLavorazione: 20,

  // / <summary>
  // /     Dichiarazione completata e non modificabile
  // / </summary>
  Completa: 30,

  // / <summary>
  // / Dichiarazione che deve essere controllata (Audit)
  // / </summary>
  DaControllare: 31,

  // / <summary>
  // /     Dichiarazione completa di cui è stato generato il telematico (Trasmessa CGN)
  // / </summary>
  DaInviare: 40,

  // / <summary>
  // / Dichiarazione da trasmettere (Agenzia Entrate)
  // / </summary>
  DaTrasmettere: 41,

  // / <summary>
  // / La trasmissione all'ente non è riuscita
  // / </summary>
  TrasmissioneNonRiuscita: 45,

  // / <summary>
  // /     Dichiarazione trasmessa all'agenzia delle entrate in modo manuale (Gestito solo per successioni)
  // / </summary>
  TrasmessaManualmente: 50,

  // / <summary>
  // /    Dichiarazione trasmessa a cui è stata allegata la ricevuta (Agenzia Entrate)
  // / </summary>
  TrasmessaAutomaticamente: 60,

  // / <summary>
  // /     Dichiarazione consegnata manualmente
  // / </summary>
  ConsegnaManuale: 70,

  // / <summary>
  // / Dichiarazione da annullare
  // / </summary>
  DaAnnullare: 80,

  // / <summary>
  // / Dichiarazione annullata con ricevuta
  // / </summary>
  AnnullataAE: 90,

  // / <summary>
  // / Dichiarazione scartata per codice fiscale
  // / </summary>
  ScartataCF: 100,

  // / <summary>
  // / Dichiarazione scartata per precompilato
  // / </summary>
  ScartataPrecompilato: 101,

  // / <summary>
  // / Dichiarazione scartata per ricalcolo
  // / </summary>
  ScartataRicalcolo: 102,

  // / <summary>
  // / Dichiarazione scartata dall'ente incaricato (Agenzia Entrate)
  // / </summary>
  ScartataEnte: 103,

  // / <summary>
  // / Dichiarazione scartata da Audit
  // / </summary>
  ScartataAudit: 104,

  // / <summary>
  // / Dichiarazione bloccata CAF
  // / </summary>
  BloccataCAF: 110,

  // / <summary>
  // / Dichiarazione bloccata per integrativa
  // / </summary>
  BloccataIntegrativa: 111,

  // / Stampata
  Stampata: 115,

  //  Trasmessa
  TrasmessaEPASA: 120,

  // Scartata EPASA
  ScartataEPASA: 130,

  AccoltaINPS: 135,

  RifiutataINPS: 140,

  InviataINPS: 145,

  ReiezioneINPS: 150,
};

const toString = (tipo, errori) => {
  switch (tipo) {
    case StatoDichiarazione.AnnoPrecedente:
      return 'Anno precedente';
    case StatoDichiarazione.Importabile:
      return 'Anno precedente';
    case StatoDichiarazione.InLavorazione:
      return errori ? 'Errata' : 'In lavorazione';
    case StatoDichiarazione.Completa:
      return 'Completa';
    case StatoDichiarazione.DaInviare:
      return 'Trasmessa CGN';
    case StatoDichiarazione.Tardiva:
      return 'Tardiva';
    case StatoDichiarazione.TrasmessaManualmente:
      return 'Trasmessa manualmente';
    case StatoDichiarazione.TrasmessaAutomaticamente:
      return 'Ricevuta A.E.';
    case StatoDichiarazione.ConsegnaManuale:
      return 'Consegna manuale';
    case StatoDichiarazione.DaControllare:
      return 'Controllo Audit';
    case StatoDichiarazione.DaTrasmettere:
      return 'Inviata A.E.';
    case StatoDichiarazione.DaAnnullare:
      return 'Da annullare A.E.';
    case StatoDichiarazione.Annullata:
      return 'Annullata';
    case StatoDichiarazione.AnnullataAE:
      return 'Annullata A.E.';
    case StatoDichiarazione.ScartataCF:
      return 'Scartata Codice Fiscale';
    case StatoDichiarazione.ScartataPrecompilato:
      return 'Scartata Precompilato';
    case StatoDichiarazione.ScartataRicalcolo:
      return 'Scartata Ricalcolo';
    case StatoDichiarazione.ScartataEnte:
      return 'Scartata A.E.';
    case StatoDichiarazione.ScartataAudit:
      return 'Scartata Audit';
    case StatoDichiarazione.BloccataCAF:
      return 'Bloccata CAF';
    case StatoDichiarazione.BloccataIntegrativa:
      return 'Bloccata Integrativo';
    case StatoDichiarazione.Stampata:
      return 'Stampata';
    case StatoDichiarazione.TrasmessaEPASA:
      return 'In lavorazione EPASA';
    case StatoDichiarazione.ScartataEPASA:
      return 'Scartato EPASA';
    case StatoDichiarazione.RifiutataINPS:
      return 'Rifiutata INPS';
    case StatoDichiarazione.InviataINPS:
      return 'Inviata INPS';
    case StatoDichiarazione.AccoltaINPS:
      return 'Accolta INPS';
    case StatoDichiarazione.ReiezioneINPS:
      return 'Reiezione INPS';
    default:
      return '';
  }
};

StatoDichiarazione.stringify = toString;

export default StatoDichiarazione;
